module.exports = __webpack_public_path__ + "img/ReservationValidate.ed26c25b.svg";